import {EventModel} from 'event/models/Event'
import {useFormik} from 'formik'
import {PriceInput, PriceRange} from 'organization/Event/Tickets'
import React from 'react'
import {Button} from 'react-bootstrap'
import styled from 'styled-components'
import useEventPayment from 'organization/Billing/Payments/useEventPayment'
import {useOrganizationBilling} from 'organization/Billing/Providers/OrganizationBillingProvider'

import {formatUserDay} from 'utils/lib/date'
import moment from 'moment'
import {useI18n} from 'i18n/I18nContext'
import {appLocaleToBcp47} from 'i18n/locales'
import {
  getEventActivationDayPriceEur,
  getEventDayListAndPromoEur,
  eventHasDayPricePromo,
} from 'event/ticketPrices'

interface EventDatesFormValues {
  date: string
  duration: number
}

export function EventDates(props: {event: EventModel | null}) {
  const {event} = props
  const {t, locale} = useI18n()
  const {payPayment} = useOrganizationBilling()
  const {payment} = useEventPayment()

  const dayDisplay = getEventActivationDayPriceEur(event)
  const {list, promo} = getEventDayListAndPromoEur(event)
  const showPromo = eventHasDayPricePromo(event) && promo != null

  const {handleChange, values, setFieldValue, handleSubmit} = useFormik({
    initialValues: {
      date: event?.date
        ? moment(event.date).format('YYYY-MM-DD')
        : moment().format('YYYY-MM-DD'),
      duration: event?.duration ?? 1,
    },
    onSubmit: async (values: EventDatesFormValues) => {
      payPayment(
        payment({
          date: values.date,
          duration: values.duration,
        }),
      )
    },
  })

  const handleSliderChange = (e: any) => {
    setFieldValue('duration', Number(e.target.value))
  }

  const handleInputChange = (e: any) => {
    setFieldValue('duration', Number(e.target.value))
  }

  return (
    <div className="create__event-area mb-20 col-12">
      <div className="body__card-wrapper attendant__wrapper">
        <form onSubmit={handleSubmit}>
          <EventStatusHolder>
            <div>
              <p>
                <b>{t('orgEventBilling.statusLabel')} </b>
                <b style={{color: 'red'}}>{t('orgEventBilling.inactive')}</b>
              </p>

              <ActionHolder>
                <h5>{t('orgEventBilling.mustPay')}</h5>
                <p>
                  {t('orgEventBilling.priceLabel')}{' '}
                  {showPromo ? (
                    <>
                      <s>
                        {list.toFixed(2)} € {t('orgMar.pricePerDaySuffix')}
                      </s>{' '}
                      <b>
                        {promo!.toFixed(2)} € {t('orgMar.pricePerDaySuffix')}
                      </b>
                    </>
                  ) : (
                    <b>
                      {dayDisplay.toFixed(2)} € {t('orgMar.pricePerDaySuffix')}
                    </b>
                  )}
                </p>
                <div className="create__input-wrapper">
                  <div className="row g-20 ">
                    <div className="singel__input-field mb-15">
                      <label className="input__field-text">
                        {t('orgEventBilling.eventDate')}
                      </label>
                      <input
                        name="date"
                        type="date"
                        onChange={handleChange}
                        lang={appLocaleToBcp47(locale)}
                        value={values.date}
                      />
                    </div>
                  </div>
                </div>
                {t('orgEventBilling.selectDuration')}
                <SliderHolder>
                  <PriceRange
                    type="range"
                    min="1"
                    max="7"
                    step="1"
                    value={values.duration}
                    onChange={handleSliderChange}
                  />

                  <PriceInput
                    type="number"
                    value={values.duration}
                    onChange={handleInputChange}
                  />
                </SliderHolder>
                <p>
                  {t('orgEventBilling.activeFrom')}{' '}
                  {formatUserDay(moment(values.date).toDate())}{' '}
                  {t('orgEventBilling.dateTo')}{' '}
                  {formatUserDay(
                    moment(values.date)
                      .add(values.duration - 1, 'days')
                      .toDate(),
                  )}{' '}
                  {t('orgEventBilling.inclusive')}
                </p>
                <PayButtonHolder>
                  <TotalPrice>
                    {t('orgEventBilling.totalPrice')}{' '}
                    {(values.duration * dayDisplay).toFixed(2)} €
                    <br />
                  </TotalPrice>

                  <Button className="input__btn w-auto" type="submit">
                    {t('orgEventBilling.payActivate')}
                  </Button>
                </PayButtonHolder>
              </ActionHolder>
            </div>
          </EventStatusHolder>
        </form>
      </div>
    </div>
  )
}

const EventStatusHolder = styled.div`
  align-items: center;
`

const TotalPrice = styled.div`
  font-size: 20px;
`

const PayButtonHolder = styled.div`
    display: flex;
    align-items: center;
    justify-content: end;
    gap: 45px;
}
`

const SliderHolder = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`

const ActionHolder = styled.div`
  border: 1px solid #f7426f;
  border-radius: 5px;
  background-color: var(--clr-bg-pink);
  padding: 15px;
  margin-top: 15px;
`
